import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@cian/ui-kit';
import { handleDynamicCalltracking, EPlatformTypes, EPageTypes } from '@cian/frontend-newbuilding-call-component';

import { useApplicationContext } from 'shared/utils/applicationContext';
import { INewbuildingBuilder, ISeller } from '../../types/newbuilding/builder';
import { trackShowPhone } from '../../analytics/call';
import { phoneToString } from '../../utils/phone/phoneToString';
import { gaLabelSelector } from 'shared/selectors/newbuilding';
import { useCallAnalytics } from '../../hooks/useCallAnalytics';

export interface ICallBuilderContainerProps {
  placeType?: string;
  openAction?: string;
  target: INewbuildingBuilder | ISeller;
  isTargetBuilder: boolean;
}

export const CallBuilderContainer: React.FC<ICallBuilderContainerProps> = ({
  placeType = 'CallBuilder',
  target,
  openAction = 'Open_jk_card',
  isTargetBuilder,
}) => {
  const gaLabel = useSelector(gaLabelSelector);
  const { httpApi, logger } = useApplicationContext();
  const { trackActionCall } = useCallAnalytics();

  const phone = phoneToString(target.phone);
  const siteBlockId = target.dynamicCalltracking?.siteBlockId;

  const trackActionOpenContactsCall = React.useCallback(() => {
    trackShowPhone(openAction, gaLabel);
    if (isTargetBuilder) {
      trackActionCall(target as INewbuildingBuilder);
    }
  }, [gaLabel, target, isTargetBuilder, openAction]);

  const handleClick = React.useCallback(async () => {
    let dynamicPhone = null;

    if (siteBlockId) {
      const response = await handleDynamicCalltracking({
        logger,
        httpApi,
        blockId: siteBlockId,
        platformType: EPlatformTypes.WebMobile,
        pageType: EPageTypes.NewbuildingCard,
        placeType,
      });

      dynamicPhone = response.notFormattedPhone ? `+${response.notFormattedPhone}` : response.notFormattedPhone;
    }

    trackActionOpenContactsCall();

    const tel = dynamicPhone || phone;
    window.location.href = `tel:${tel}`;
  }, [httpApi, logger, phone, placeType, siteBlockId, trackActionOpenContactsCall]);

  /* istanbul ignore next */
  if (!phone) {
    return null;
  }

  return (
    <Button data-testid="CallText" onClick={handleClick} fullWidth>
      Позвонить
    </Button>
  );
};
